import styled from 'styled-components';

const SliderReviewsStyle = styled.section`
	--distanceSwiperTop: var(--sp9x);
	--sliderIconsDistance: var(--sp1x);
	--sliderIconSize: var(--sp2-5x);
	--swiperSlideWidth: calc(34% - 2.5 * var(--colPadding));
	--marginSlideText: var(--sp3x);
	--paddingTPSlide: var(--sp6x);
	--paddingLRSlide: var(--sp4x);
	--borderRadiusSlide: var(--sp3x);
	--gapSlide: var(--sp2x);
	--iconWH: var(--sp7x);

	overflow: hidden;

	.top-block {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.slider-icons-blok {
		display: flex;
		align-items: center;
		gap: var(--sliderIconsDistance);
	}

	.slider-icon {
		font-size: var(--sliderIconSize);
		will-change: transform;
		transition: transform var(--trTime) ease-out;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		width: var(--iconWH);
		height: var(--iconWH);
		border: 2px solid var(--green1000);
		border-radius: 50%;
		position: relative;
		overflow: hidden;
	}

	.wrapper-real-icon {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: var(--trTime) ease-out;
	}

	.hover-icon-wrap {
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		right: 100%;
		transition: var(--trTime) ease-out;

		&.right {
			left: 100%;
		}
	}

	.slider-block {
		position: relative;
		margin-top: var(--distanceSwiperTop);

		.empty {
			position: absolute;
			width: var(--contPaddingLR);
			background-color: var(--lightGray1000);
			height: 105%;
			z-index: 1000;
		}

		.left-empty {
			left: 0;
			transform: translate(-100%, -1%);
		}

		.right-empty {
			right: 0;
			top: 0;
			transform: translate(100%, -1%);
		}
	}

	.swiper {
		display: flex;
		height: 100%;
	}

	.swiper-wrapper {
		height: unset !important;
	}
	.swiper {
		overflow: visible !important;
	}
	.swiper-slide {
		width: var(--swiperSlideWidth);
		margin-right: var(--gutter);
		background-color: var(--green100);
		border-radius: var(--borderRadiusSlide);
		padding: var(--paddingTPSlide) var(--paddingLRSlide);

		&:last-child {
			margin-right: 0 !important;
		}
	}

	.swiper-button-disabled {
		pointer-events: none;
		cursor: default;
	}

	.wrapper-review-slider {
		overflow: hidden;
		position: relative;
		transition: border-color var(--trTime) ease-out;
	}

	.swiper-wrapper {
		height: unset !important;
		width: 100%;
	}

	.wrapper-texts {
		display: flex;
		flex-direction: column;
		gap: var(--gapSlide);
		margin: var(--marginSlideText) 0 var(--marginSlideText);
	}

	.active {
		background-color: var(--green1000);
		transition: background-color 0.3s ease;
		cursor: pointer;

		i {
			color: var(--lightGray1000);
		}
	}

	.inactive {
		background-color: var(--lightGray1000);
		transition: background-color 0.3s ease;
		cursor: default;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.slider-icon {
				&.active {
					&:hover {
						.hover-icon-wrap {
							right: 0;
							&.right {
								left: 0;
							}
						}
						.wrapper-real-icon {
							transform: translateX(-100%);

							&.left {
								transform: translateX(100%);
							}
						}
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceSwiperTop: var(--sp7x);
		--paddingTP: var(--sp5x);
		--marginSlideTextTP: var(--sp2x);
		--gapSlide: var(--sp1x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceSwiperTop: var(--sp5x);
		--paddingTP: var(--sp4x);
		--paddingLR: var(--sp3x);
		--borderRadius: var(--sp2x);
		--marginSlideTextTP: var(--sp2-5x);
		--gapSlide: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sliderIconSize: var(--sp1-5x);
		--iconWH: var(--sp5x);
		--distanceSwiperTop: var(--sp4x);
		--paddingTP: var(--sp3x);
		--paddingLR: var(--sp2-5x);
		--marginSlideTextTP: var(--sp2x);
		--gapSlide: var(--sp1x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--gapSlide: var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--swiperSlideWidth: calc(51% - 2.5 * var(--colPadding));
		--paddingTP: var(--sp2-5x);
		--paddingLR: var(--sp2x);
		--iconWH: var(--sp4x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--sliderIconsDistance: var(--sp1-5x);
		--distanceSwiperTop: var(--sp3x);
		--paddingTP: var(--sp2x);
		--paddingLR: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--swiperSlideWidth: calc(100% - 1 * var(--colPadding));
		--paddingTP: var(--sp2-5x);
		--paddingLR: var(--sp2x);

		.top-block {
			flex-direction: column;
			align-items: flex-start;
			gap: var(--sp3x);
		}
	}
`;
export default SliderReviewsStyle;
